
function showTabAndTable(table, tab) {
  let tableContent = document.getElementById(table)
  let tables = document.querySelectorAll('.table-content');
  let tabs = document.querySelectorAll('.tab-guide');
  let tabSelected = document.getElementById(tab);

  SearchClasses(tables, 'table-active')
  tableContent.classList.add('table-active');
  SearchClasses(tabs, 'active-guide');
  tabSelected.classList.add('active-guide');

}

sizingTabMobile('dress-content-mobile', 'active-b');
sizingTabMobile('jumpsuits-content-mobile', 'active-b');
sizingTabMobile('pants-content-mobile', 'active-b');


function SearchClasses(object, active) {
  [...object].forEach(item => {
    let table = document.getElementById(item.id)
    if (table.classList.contains(active)) {
      table.classList.remove(active)
    }
  });
}

function sizingTabMobile(parentId, active) {
  const SizingTabs = document.querySelectorAll(`#${parentId} .top-li`);
  const parentTr = document.querySelectorAll(`#${parentId} .top-table-size tr`);
  [...SizingTabs].forEach(item => {
    item.addEventListener('click', () => {
      [...SizingTabs].forEach(remove_class => {
        remove_class.classList.remove('active-li')
      })
      item.classList.add('active-li');
      [...parentTr].forEach(itemParent => {
        [...itemParent.children].forEach(removeClass => {
          removeClass.classList.remove('active-b')
        });
        [...itemParent.children][parseInt(item.attributes['data-index'].value)].classList.add(active);
      })
    })
  });
}